import { reactive as a, readonly as r } from "vue";
import { BannerStyle as l } from "./index2.js";
import { FooterStyle as s } from "./index3.js";
const o = a({
  footerStyle: s.Normal,
  bannerStyle: l.Normal,
  showNavigation: !0,
  showSignInDialog: !1,
  showMobileMenu: !1,
  showPolicyDialog: !1,
  policyDialogType: void 0,
  showIpRedirectPrompt: !1,
  isQuebecFrench: !1,
  signInDialog: void 0,
  productInfo: void 0,
  accountCreationLink: void 0,
  signInCompletionHandler: void 0
}), p = () => r(o), h = (e) => {
  o.footerStyle = e;
}, m = (e) => {
  o.bannerStyle = e;
}, f = (e) => {
  o.showNavigation = e;
}, c = (e) => {
  o.showSignInDialog = e;
}, u = (e, n, t, i) => {
  n && (o.productInfo = n), t && (o.accountCreationLink = t), i && (o.signInCompletionHandler = i), o.signInDialog = e, c(!0);
}, v = () => {
  o.signInDialog = void 0, o.productInfo = void 0, o.showSignInDialog = !1, o.accountCreationLink = void 0, o.signInCompletionHandler = void 0;
}, S = (e) => {
  o.showIpRedirectPrompt = e;
}, w = (e) => {
  o.isQuebecFrench = e;
}, I = (e) => {
  e ? (document.body.style.height = "820px", document.body.style.overflow = "hidden") : (document.body.style.removeProperty("height"), document.body.style.removeProperty("overflow")), o.showMobileMenu = e;
}, D = (e, n = void 0) => {
  const t = document.getElementsByTagName("html")[0], i = "policy-dialog-open";
  e ? t.classList.add(i) : t.classList.remove(i), o.showPolicyDialog = e, o.policyDialogType = n;
}, b = () => {
  o.footerStyle = s.Normal, o.bannerStyle = l.Normal, o.showNavigation = !0, o.showSignInDialog = !1, o.showMobileMenu = !1, o.showPolicyDialog = !1, o.policyDialogType = void 0, o.showIpRedirectPrompt = !1, o.signInDialog = void 0, o.productInfo = void 0;
};
export {
  p as getLayout,
  u as openSignInDialog,
  b as resetLayout,
  v as resetSignInDialog,
  m as setBannerStyle,
  h as setFooterStyle,
  w as setIsQuebecFrench,
  S as setShowIpRedirectPrompt,
  I as setShowMobileMenu,
  f as setShowNavigation,
  D as setShowPolicyDialog,
  c as setShowSignInDialog
};
//# sourceMappingURL=index.js.map
